export default {
  heading: 'Open Sans, san-serif',
  body: 'Open Sans, san-serif',
  monospace: 'Menlo, monospace',
  display: 'Playfair Display, serif',
  googleFonts: ['Open Sans:300,400,500,600,700,800']
  // customFamilies: [''],
  // customUrls: [''],
}
